export default "__VITE_ASSET__Dupk6UsM__"